import Vue from 'vue'
import Vuex from 'vuex'
import ShopStore from './shop'
import ErrStore from './error'
import StatStore from './stat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // コンポーネントからのアクセス名 : 定義
    shop: ShopStore,
    err: ErrStore,
    stat: StatStore,
  }
})
